<div
  class="irembo-rightflyout-wrapper-bg"
  [ngClass]="paneOpen ? 'open' : 'closed'"
  (click)="closePane()"></div>

<div
  class="irembo-rightflyout-wrapper-sidepane p-3 shadow-lg"
  [ngClass]="paneOpen ? 'open' : 'closed'">
  <span
    (click)="closePane()"
    class="close-arrow shadow text-center align-middle d-block">
    &lt;&lt;
  </span>
  <div class="pane-top m-3 pt-5">
    <span class="close-x small" (click)="closePane()">Close X</span>
  </div>
  <h3 class="px-3">{{ title | titlecase }}</h3>
  <small class="px-3 text-muted">{{ description }}</small>
  <div class="pane-content m-3 p-3 rounded">
    <ng-content></ng-content>
  </div>
</div>
